/**
 * Actions
 */
export enum PricingCodesCategories {
  obi = 'OBI',
  recordType = 'RecordType',
  docType = 'DocType',
  security = 'Security',
}
